const assets = {
  images: {
    logo: require("./images/logo_small_new.png")
    
  }
};

export default assets;